import React from "react";
import ViewBlogs from "Pages/Blogs/view-blog";


const ViewBlogstheme = () => {
  return (
    <React.Fragment>
        <ViewBlogs/>
    </React.Fragment>
  );
};

export default ViewBlogstheme;
